(() => {
  if (customElements.get('yumi-discover')) return;
  class YumiDiscover extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const options = {signal:this.abortController.signal};
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-yd-tab]');
        if (!button || button.closest('yumi-discover') !== this) return;
        event.preventDefault();
        this.activate(button.dataset.ydTab);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.defaultPrevented) return;
        const button = event.target.closest('[data-yd-tab]');
        if (!button) return;
        const tabs = [...this.querySelectorAll('[data-yd-tab]')];
        let index = tabs.indexOf(button);
        if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') index = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = tabs.length - 1;
        else return;
        event.preventDefault();
        this.activate(tabs[index].dataset.ydTab);
        tabs[index].focus({preventScroll:true});
        tabs[index].scrollIntoView({block:'nearest',inline:'nearest'});
      }, options);
      this.addEventListener('click', event => {
        const choose = event.target.closest('.yd-quick-add .quick-add__button--choose');
        if (choose && !document.getElementById('quick-add-dialog')) {
          const link = choose.closest('product-card')?.querySelector('[ref="productCardLink"]');
          if (link?.href) {
            event.preventDefault();
            event.stopImmediatePropagation();
            window.location.assign(link.href);
          }
        }
      }, {...options,capture:true});
      document.addEventListener('shopify:block:select', event => {
        if (event.detail?.sectionId && event.detail.sectionId !== this.dataset.sectionId) return;
        const id = event.detail?.blockId;
        if (id && [...this.querySelectorAll('[data-yd-tab]')].some(button=>button.dataset.ydTab===id)) this.activate(id);
      }, options);
      this.querySelectorAll('.yd-card').forEach(card=>{
        card.querySelectorAll('.yd-quick-add button').forEach(button=>button.setAttribute('aria-label',card.dataset.ydQuickLabel));
      });
    }
    disconnectedCallback() {
      this.abortController?.abort();
    }
    activate(id) {
      const tabs = [...this.querySelectorAll('[data-yd-tab]')];
      if (!tabs.some(button=>button.dataset.ydTab===id)) return;
      tabs.forEach(button=>{
        const selected = button.dataset.ydTab===id;
        button.setAttribute('aria-selected',String(selected));
        button.tabIndex=selected?0:-1;
      });
      this.querySelectorAll('[data-yd-panel]').forEach(panel=>panel.hidden=panel.dataset.ydPanel!==id);
      this.querySelectorAll('[data-yd-feature]').forEach(panel=>panel.hidden=panel.dataset.ydFeature!==id);
      this.querySelectorAll('[data-yd-title]').forEach(title=>title.hidden=title.dataset.ydTitle!==id);
    }
  }
  customElements.define('yumi-discover',YumiDiscover);
})();
